// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3yFkW","left":"InfoRow_left__1Hp23"};